export default __webpack_public_path__ + "static/media/925.306bf7a5.png";